var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '' : _b, rest = __rest(_a, ["fill"]);
    return (_jsx("svg", __assign({ id: "trash", width: "14", height: "16", viewBox: "0 0 14 16", fill: fill, xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M13.5 2.5H10.9258L9.86328 0.726562C9.59325 0.275844 9.10641 0 8.581 0H5.419C4.89359 0 4.40675 0.275844 4.13672 0.726562L3.07422 2.5H0.5C0.222656 2.5 0 2.72266 0 3V3.5C0 3.77734 0.222656 4 0.5 4H1V14C1 15.1046 1.89544 16 3 16H11C12.1046 16 13 15.1046 13 14V4H13.5C13.7773 4 14 3.77734 14 3.5V3C14 2.72266 13.7773 2.5 13.5 2.5ZM5.37109 1.58984C5.40234 1.53516 5.46484 1.5 5.53125 1.5H8.46875C8.53516 1.5 8.59766 1.53516 8.62891 1.58984L9.17578 2.5H4.82422L5.37109 1.58984ZM11 14.5H3C2.72384 14.5 2.5 14.2762 2.5 14V4H11.5V14C11.5 14.2762 11.2762 14.5 11 14.5ZM7 13C7.27637 13 7.5 12.7764 7.5 12.5V6C7.5 5.72363 7.27637 5.5 7 5.5C6.72363 5.5 6.5 5.72363 6.5 6V12.5C6.5 12.7764 6.72363 13 7 13ZM4.5 13C4.77637 13 5 12.7764 5 12.5V6C5 5.72363 4.77637 5.5 4.5 5.5C4.22363 5.5 4 5.72363 4 6V12.5C4 12.7764 4.22363 13 4.5 13ZM9.5 13C9.77637 13 10 12.7764 10 12.5V6C10 5.72363 9.77637 5.5 9.5 5.5C9.22363 5.5 9 5.72363 9 6V12.5C9 12.7764 9.22363 13 9.5 13Z", fill: fill }) })));
});
